/**
 *
 * @author Matthew Rawson @ 02/05/2018 10:02
 * @description
 * @notes
 */
import React, {Fragment} from "react"
import PropTypes from "prop-types"
import {get} from "lodash"

import {Para} from "@irati/ui/src/Labels"
import id from "@irati/utils/id"

import {isScheduleEnabled} from "../../../helpers/schedule"
import {WeekPeriodSummary} from "../"


const ENPS = ({schedule, ...props}) => {
  const idNamespace = id("ENPS", props)
  const isEnabled = isScheduleEnabled(schedule)
  const includeENPS = get(schedule, "preferences.includeENPS", false) || false

  return (
    <Fragment>
      {!isEnabled && (
        <Para>
          <span>eNPS is often regarded as the industry standard way of measuring employee engagement levels,
                    based on answers to the following statement: &quot;I would refer a friend to work at </span>
          <span>{schedule.preferences.placeholders.tenant} </span>
          <span>if there was an appropriate job available&quot;.</span>
        </Para>
      )}

      {isEnabled && (
        <Fragment>

          {includeENPS && (
            <Fragment>
              <span id={id("yes", idNamespace)}>You&apos;ve chosen to measure your eNPS score </span>
              <strong>
                <span>every </span>
                <WeekPeriodSummary id={idNamespace} schedule={schedule} property="preferences.eNPSPeriodValue" />
                <span>.</span>
              </strong>
            </Fragment>
          )}

          {!includeENPS && (
            <span id={id("no", idNamespace)}>You&apos;ve chosen not to measure your eNPS score.</span>
          )}
        </Fragment>
      )}
    </Fragment>
  )
}

ENPS.propTypes = {
  schedule: PropTypes.object
}
ENPS.defaultProps = {
  schedule: {}
}

export default ENPS
